/* eslint-disable react/no-unescaped-entities */
import react from 'react'

interface BigQueryConnectedAppProps {
  id?: string
  googleCloudProjectId?: string
  bigQueryDatasetId?: string
  isConnected?: boolean
  sessionId?: string
  oauthCallbackBaseUrl?: string
}

const BigQueryConnectedApp = (props: BigQueryConnectedAppProps) => {
  const [infoHidden, setInfoHidden] = react.useState(true)
  const [id, setId] = react.useState(props.id)
  const [googleCloudProjectId, setGoogleCloudProjectId] = react.useState(props.googleCloudProjectId)
  const [saved, setSaved] = react.useState(false)
  const [bigQueryDatasetId, setBigQueryDatasetId] = react.useState(props.bigQueryDatasetId)
  const [isConnected, setIsConnected] = react.useState(props.isConnected)
  const [error, setError] = react.useState('')

	async function handleSaveConfigData(data: {[key: string]: any}) {
    // Save data
		const resp = await fetch(`/api/bigquery/data`, {
			method: 'post',
			headers: {
				Session: props.sessionId!,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({id, ...data})
		})

    // Handle errors
    if (!resp.ok) {
      console.error('Failed to save config data', resp)
      setError('Error saving data')
      return
    }

    // Prase response
    const json = await resp.json()
    console.info('saved config data', json)
    setId(json.id)

    // Provide user feedback
    setSaved(true)
    setError('')

    setTimeout(() => {
      setSaved(false)
    }, 4000) 

		return json.success
	}

  async function handleDeleteConnection() {
    const resp = await fetch(`/api/bigquery/data`, {
      method: 'delete',
      headers: {
				Session: props.sessionId!,
      }
    })

    if (resp.ok) {
      setIsConnected(false)
    } else {
      console.error('error deleting connection', await resp.text())
      setError('Error deleting connection')
    }
  }

  react.useEffect(() => {
    console.log('updating state', props)
    setId(props.id)
    setGoogleCloudProjectId(props.googleCloudProjectId)
    setBigQueryDatasetId(props.bigQueryDatasetId)
    setIsConnected(props.isConnected)
  }, [props.id, props.googleCloudProjectId, props.bigQueryDatasetId, props.isConnected])

  return (
    <div
    className='border-b border-gray-300 mb-5 bg-slate-200 p-8'
   >
   <h2 className="text-2xl text-slate-500">
     <span className="text-blue-700 font-extrabold">BigQuery</span><button className='underline text-blue-500 text-sm ml-2' onClick={() => setInfoHidden(!infoHidden)}>(help)</button>
   </h2>
  <div className={`${infoHidden ? 'hidden' : 'block'} bg-slate-100 p-8 my-5`}>
    <p className='text-sm'>
      Your Google Cloud Project ID, and BigQuery Dataset ID can be found in your <a href="https://console.cloud.google.com/bigquery">Google Cloud Console</a>. 
    </p>
    <img src="/assets/images/bigquery-project-id.png" alt="BigQuery IDs" />  
  </div>
   <div>
    <p className='text-sm mt-3'>
      BigQuery connections will populate a new <span className='font-mono border-dashed border-2 px-1 border-slate-300'>dessertdata</span> dataset with
      several tables depending on which data sources are connected.
    </p>

    <h3 className='text-lg mt-4 font-bold'>Table Details</h3>
    <ul className='mt-2'>
      <li>
        <h4 className='block font-bold text-sm mb-1'>default_[source]</h4>
        <p className='block italic text-sm mt-0'>
          The "default" tables power the unified_report view.  This is the source data from each 
          connected data source.  These tables power the data in the unified_report view, and are
          not intended to be queried directly.
        </p>
      </li>
      <li>
        <h4 className='block font-bold text-sm mb-1'>unified_report</h4>
        <p className='block italic text-sm mt-0'>
          This view contains selected report metrics for each connected data source.
        </p>
      </li>
    </ul>
   </div>
    <div>
      <section className='my-8'>
        <label htmlFor="google-cloud-project-id" className='block mt-6 font-bold'>Google Cloud Project ID</label>
        <input 
          id="google-cloud-project-id" 
          className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          type="text"
          placeholder="dessertdata"
          value={googleCloudProjectId}
          onChange={(e) => setGoogleCloudProjectId(e.target.value)}
        />
        
        {/* <label htmlFor="bigquery-dataset-id" className='block mt-6'>BigQuery Dataset Id - <span className='italic'>This needs to be created prior to syncing</span></label>
        <input 
          id="bigquery-dataset-id" 
          className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          type="text"
          placeholder="dessertdata"
          value={bigQueryDatasetId}
          onChange={(e) => setBigQueryDatasetId(e.target.value)}
        /> */}

        <button 
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold mt-4 py-2 px-4 rounded block"
          onClick={() => handleSaveConfigData({googleCloudProjectId, bigQueryDatasetId})}
        >
          { saved ? ' ✔️ ' : 'Save' }
        </button>
      </section>
      2. Connect BigQuery { isConnected && <span className='text-green-500'>✅</span>}

      { !isConnected &&
        <div className='text-med'>
          <a className='inline-block border border-blue-500 bg-blue-500 text-white font-bold py-2 px-4 rounded mt-4'
            href={`https://accounts.google.com/o/oauth2/v2/auth?scope=https://www.googleapis.com/auth/bigquery&access_type=offline&include_granted_scopes=true&response_type=code&state=state_parameter_passthrough_value&redirect_uri=${props.oauthCallbackBaseUrl}/oauth-callback/bigquery&client_id=944574741849-i5m4otptqf40fsvltcagq858r867jur8.apps.googleusercontent.com&prompt=consent`}>
          Authorize</a>
        </div>
      }
      { isConnected &&
        <div className='text-med'>
          <a 
            href={`https://accounts.google.com/o/oauth2/v2/auth?scope=https://www.googleapis.com/auth/bigquery&access_type=offline&include_granted_scopes=true&response_type=code&state=state_parameter_passthrough_value&redirect_uri=${props.oauthCallbackBaseUrl}/oauth-callback/bigquery&client_id=944574741849-i5m4otptqf40fsvltcagq858r867jur8.apps.googleusercontent.com&prompt=consent`}
          >
            Reauthenticate</a>

          <button 
            className=" text-red-800 hover:underline mt-4 px-4 rounded"
            onClick={() => handleDeleteConnection()}>Delete Connection
          </button>  
        </div>
      }
      <div className='block text-red-600'>{ error }</div>
    </div>
    
   </div>
  )
}

export default BigQueryConnectedApp